<template>
  <a
    :href="link"
    download
    class="file-link spacex-8"
    target="_blank"
    :class="{ 'file-link_overlay': overlay }"
  >
    <slot name="icon">
      <div class="file-link__icon">
        <Icon type="file-blank" :color="iconColor" size="16" />
      </div>
    </slot>
    <div>
      <div class="file-name">{{ fileName }}</div>
      <div class="file-size">{{ formatBytes(size, 0) }}, {{ $t('Click to view') }}</div>
    </div>
  </a>
</template>

<script>
  import fileName from '@/utils/formatting/file-name';
  import absoluteLink from '@/utils/formatting/absolute-link';
  import Icon from '@/components/ui/Icon';
  import { formatBytes } from '@/utils/formatting/format-bytes';

  export default {
    name: 'FileLink',
    components: {
      Icon,
    },
    props: {
      fileLink: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: false,
      },
      isFileRepositoryLink: {
        type: Boolean,
        default: true,
      },
      overlay: {
        type: Boolean,
        default: false,
      },
      size: String,
    },
    computed: {
      fileName() {
        return this.name || fileName(this.fileLink);
      },
      link() {
        return absoluteLink(this.fileLink, this.isFileRepositoryLink);
      },
      iconColor() {
        return this.overlay ? 'accent' : 'oncolor';
      },
    },
    methods: {
      absoluteLink,
      formatBytes,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .file-link {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: $primary600;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;

    &__icon {
      width: 32px;
      height: 32px;
      background-color: $primary500;
      border-radius: 30px;

      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 8px;
    }

    &_overlay {
      color: white;
      .file-link__icon {
        background-color: white;
      }
    }
  }

  .file-name {
    display: flex;
    align-items: center;
    overflow: hidden;
    word-break: break-all;
  }

  .file-size {
    opacity: 0.8;
  }
</style>
